import * as React from "react";
import { SVGProps, Ref, forwardRef } from "react";
const SvgComponent = (props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="1em"
        height="1em"
        fill="none"
        viewBox="0 0 20 20"
        ref={ref}
        {...props}
    >
        <path
            fill="currentColor"
            fillRule="evenodd"
            d="M4.406 10a9.544 9.544 0 0 0 2.065 2.539l1.127-1.127a2.703 2.703 0 0 1 .429-3.359 2.845 2.845 0 0 1 3.364-.434l.983-.983c-.784-.452-1.594-.704-2.374-.704-1.027 0-2.106.437-3.109 1.19C5.898 7.87 5.024 8.897 4.406 10Zm8.987-4.383C12.361 4.958 11.2 4.532 10 4.532c-1.42 0-2.787.597-3.95 1.472C4.883 6.88 3.877 8.07 3.17 9.34c-.227.41-.227.907 0 1.317a10.96 10.96 0 0 0 2.309 2.873l-.742.742a.7.7 0 1 0 .99.99l9.535-9.536a.7.7 0 1 0-.99-.99l-.879.88Zm-3.075 3.075a1.44 1.44 0 0 0-1.315.365 1.305 1.305 0 0 0-.352 1.302l1.667-1.667Zm3.794-1.684a.7.7 0 0 1 .99.013 11.042 11.042 0 0 1 1.727 2.32v.001c.228.41.228.907 0 1.316-.706 1.272-1.712 2.46-2.879 3.338-1.163.875-2.53 1.471-3.95 1.471-.801 0-1.585-.19-2.322-.51a.7.7 0 1 1 .558-1.284c.592.257 1.186.395 1.764.395 1.027 0 2.106-.437 3.109-1.19.992-.747 1.867-1.774 2.485-2.878a9.648 9.648 0 0 0-1.495-2.002.7.7 0 0 1 .013-.99Z"
            clipRule="evenodd"
        />
    </svg>
);
const ForwardRef = forwardRef(SvgComponent);
export default ForwardRef;
